import Vue from 'vue'
import * as types from 'store/mutation-types'

const state = {
  unusual: null
}

const mutations = {
  [types.LOAD_RANK_LIST_UNUSUAL](state, data) {
    state.unusual = {}
    data.forEach(item => (state.unusual[item.id] = item))
  },
  [types.UPDATE_RANK_LIST_ITEM](state, data) {
    const fn = (item, idx, arr) => {
      if (
        data &&
        item.symbol === data.symbol &&
        data.secType === 'STK' &&
        data.changeRate &&
        data.latestPrice
      ) {
        item.changeRate = data.changeRate
        item.latestPrice = data.latestPrice
      }
      return item
    }
    Object.entries(state.unusual || {}).forEach(([name, cate]) => {
      cate.data = cate.data.map(fn)
      Vue.set(state.unusual, name, cate)
    })
    Vue.set(state, 'unusual', Object.assign({}, state.unusual))
  }
}

const actions = {
  loadRankListUnusual({ commit }, [market, inParams]) {
    const path =
      {
        usMarket: '',
        hkMarket: '/hkstock',
        aMarket: '/astock'
      }[market] || ''
    const param = { limit: 10, ...inParams }

    return Vue.http
      .get(`~stock${path}/explore/unusual?limit=25`, {
        params: param
      })
      .then(({ data: result }) => {
        commit(types.LOAD_RANK_LIST_UNUSUAL, result.items)
      })
  }
}

export default { state, mutations, actions }
